import dayjs, { Dayjs } from "dayjs";

export const formatDateForBE = (date: Dayjs) => date ? dayjs(date).format(dateFormatForBE) : "";

export const dateFormat = "DD/MM/YYYY";
export const dateFormatForBE = "YYYY-MM-DD";

export const dateTimeFormat = "DD/MM/YYYY HH:mm";
export const dateTimeFormatForBE = "YYYY-MM-DD HH:mm:ss";